import { BasicsClass } from '@/common/BasicsClass';
import { Util } from '@/common/util';

export class PreTransferAccountAPI extends BasicsClass {
  public apiUrls: any = new Map([
    ['getPreTransferAccountList', {
      url: '/admin/allin/transfers',
      name: 'list',
      label: '预转账列表'
    }],
    // ['updatePreTransferAccount', {
    //   url: '/admin/financeData/shopEdit',
    //   name: 'edit',
    //   label: '编辑预转账'
    // }],
    ['retryPreTransfer', {
      url: '/admin/allin/transferRevisit',
      name: 'retry-transfer-account',
      label: '重试转账'
    }],

    // ['exportExcelPreTransferAccountList', {
    //   url: '/admin/financeData/exportList',
    //   name: 'export-excel',
    //   label: '导出'
    // }],
    // ['addPreTransferAccount', {
    //   url: '/admin/quickReply/add',
    //   name: 'add',
    //   label: '添加预转账'
    // }],
    // ['deletePreTransferAccount', {
    //   url: '/admin/quickReply/delete',
    //   name: 'delete',
    //   label: '删除预转账'
    // }],

  ])
  // 预转账列表
  public getPreTransferAccountList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('getPreTransferAccountList').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // 重试转账
  public retryPreTransfer(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
    const apiUrls = this.apiUrls

    const url = apiUrls.get('retryPreTransfer').url

    this.BasicPost(url, {
        ...params
    }, false, false, false, successCb, failCb, showLoading)
  }

  // // 修改预转账
  // public updatePreTransferAccount(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('updatePreTransferAccount').url

  //   this.BasicPost(url, {
  //       ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 导出预转账
  // public exportExcelPreTransferAccountList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('exportExcelPreTransferAccountList').url

  //   this.BasicPost(url, {
  //       ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }
  // 添加预转账
  // public addPreTransferAccount(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('addPreTransferAccount').url

  //   this.BasicPost(url, {
  //       ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }

  // 删除预转账
  // public deletePreTransferAccount(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
  //   const apiUrls = this.apiUrls

  //   const url = apiUrls.get('deletePreTransferAccount').url

  //   this.BasicPost(url, {
  //       ...params
  //   }, false, false, false, successCb, failCb, showLoading)
  // }
}